import { render, staticRenderFns } from "./itemFrame.vue?vue&type=template&id=6a64e672&scoped=true"
import script from "./itemFrame.vue?vue&type=script&lang=js"
export * from "./itemFrame.vue?vue&type=script&lang=js"
import style0 from "./itemFrame.vue?vue&type=style&index=0&id=6a64e672&prod&lang=scss&scoped=true"
import style1 from "./itemFrame.vue?vue&type=style&index=1&id=6a64e672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64e672",
  null
  
)

export default component.exports